var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_44_6",
    "data-name": "Component 44 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M616.811,12.225a.6.6,0,0,0,.09-.007l2.524-.442a.147.147,0,0,0,.079-.042l6.358-6.359a.15.15,0,0,0,.033-.049.148.148,0,0,0,0-.114.15.15,0,0,0-.033-.049l-2.493-2.495a.152.152,0,0,0-.213,0L616.8,9.027a.157.157,0,0,0-.042.079l-.442,2.523a.5.5,0,0,0,.141.447A.508.508,0,0,0,616.811,12.225Zm1.011-2.616,5.44-5.439,1.1,1.1-5.441,5.439-1.333.235Zm8.323,3.876h-11.04a.479.479,0,0,0-.48.48v.54a.12.12,0,0,0,.12.12h11.761a.12.12,0,0,0,.12-.12v-.54A.479.479,0,0,0,626.145,13.485Z",
    transform: "translate(-614.625 -2.625)",
    fill: "#33af89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1e46101849e589115783c5af40cc5bf3.svg";
export { ForwardRef as ReactComponent };